import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { saveAs } from '@progress/kendo-file-saver';
import { lastValueFrom, timer } from 'rxjs';
import { AttachmentBus } from '../../shared/models/AttachmentBus';
import { DomSanitizer } from '@angular/platform-browser';
import { CDocument } from '../../shared/models/CDocument';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { UploadComponent, SelectEvent, FileInfo, UploadEvent } from '@progress/kendo-angular-upload';
import { BaseGridEditAttachmentsComponent } from '@app/cp/shared/base-components/base-grid-edit-attachments.component';
import { FileState } from '@progress/kendo-angular-upload';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { OrderService } from '@app/cp/shared/services/order.service';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { MessageType } from '../../shared/enums/MessageType';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { UseCPLoader, ICPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';
import { CommonValues } from '@app/cp/shared/static/CommonValues';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';

@UseCPLoader()
@Component({
    selector: 'order-attachments',
    templateUrl: './order-attachments.component.html',
    styleUrls: ['./order-attachments.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class OrderAttachmentsComponent extends BaseGridEditAttachmentsComponent<AttachmentBus, null, OrderService> implements OnInit {
    onDrop(event: any) {

    }
    compLoader: ICPLoader = this as any;
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, sanitizer: DomSanitizer, svc_data: OrderService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, sanitizer, featureFlagService);
        this.svc_data = svc_data;
        this.className = "AttachmentBus";
        this.appCode = "OrderAttachments";
        this.callSaveIndividualInsteadOfSave = true;
        this.disableCpSearchDialog();
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'id': new UntypedFormControl(),
            'referenceId': new UntypedFormControl(),
            'attachmentName': new UntypedFormControl(),
            'attachmentDesc': new UntypedFormControl(),
            'attachmentType': new UntypedFormControl(),
            'attachment': new UntypedFormControl(),
            'visibleToCustomer': new UntypedFormControl(),
            'personName': new UntypedFormControl(),
            'personId': new UntypedFormControl(),
            'code': new UntypedFormControl(),
            'codeId': new UntypedFormControl(),
            'orderAttachmentTypeId': new UntypedFormControl('', Validators.required),
            'orderAttachmentTypeName': new UntypedFormControl()

        });

    }
    setForm() {
        this.editForm.patchValue({
            id: this.selectedData.id,
            referenceId: this.isNew ? this._parentId : this.selectedData.referenceId,
            attachmentName: this.selectedData.attachmentName,
            attachmentDesc: this.selectedData.attachmentDesc,
            attachmentType: this.selectedData.attachmentType,
            attachment: this.selectedData.attachment,
            visibleToCustomer: this.selectedData.visibleToCustomer,
            personName: this.selectedData.personName,
            personId: this.selectedData.personId,
            code: this.selectedData.code,
            codeId: this.selectedData.codeId,
            orderAttachmentTypeId: this.selectedData.orderAttachmentTypeId,
            orderAttachmentTypeName: this.selectedData.orderAttachmentTypeName
        });
    }
    setFromReferenceData(data: AttachmentBus) {
        data.personName = this.personName(data.personId);
        return data;
    }
    protected getChangedObject(data: AttachmentBus) {
        let busObj: AttachmentBus = new AttachmentBus(data);
        busObj.setParentId(this._parentId);
        busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        busObj.setBeforeSave();
        return busObj;
    }
    orderAttachmentTypeNameCBOChanged(e: any, dataItem: AttachmentBus) {

        this.editForm.patchValue({
            orderAttachmentTypeName: e.description
        });
    }

    private isVisibleAttachmentType(type: string): boolean {
        const attachmentType = (type || '').toLowerCase();
        return !(attachmentType.includes('.msg')
            || attachmentType.includes('.docx')
            || attachmentType.includes('.xlsx'));
    }

    saveIndividual(data: AttachmentBus): Promise<BaseMessageInfo> {
        if (this.dataLoading == false) {
            this.dataLoading = true;
            let busObj: AttachmentBus = this.getChangedObject(data);

            let retInfo: BaseMessageInfo = new BaseMessageInfo();
   
            if (this.files && this.files.length > 0) {
                if (data.isAdded) { busObj.id = '' };
                return new Promise((resolve, reject) => {
                    lastValueFrom(this.svc_data.uploadFiles(this.svc_data.baseUrl + "UploadFile", this.files, busObj)).then((info: BaseMessageInfo) => {
                        if (!info.saveError && !info.existsAlready && !info.warning && info.primaryReturn) {
                            busObj.isViewable = this.isVisibleAttachmentType(busObj.attachmentType);
                            busObj.id = info.primaryReturn.orderAttachmentId;
                            retInfo.primaryReturn = busObj;
                            this.notify(this.appCode + " Saved Successfully!");
                        }
                        else {
                            retInfo.message = info.message;
                            retInfo.saveError = true;
                            this.saveError(info.primaryReturn as AttachmentBus, info.message ?? `Unable to upload file. ${CommonValues.ErrorMessages_BaseErrorSuffix}`);
                        }
                        this.clearUpload();
                        resolve(retInfo);
                        this.dataLoading = false;
                    }, (err) => {
                        console.error(err);
                        retInfo.message = `Unable to upload file. ${CommonValues.ErrorMessages_BaseErrorSuffix}`;
                        retInfo.saveError = true;
                        this.clearUpload();
                        this.saveError(busObj, retInfo.message);
                        reject(retInfo);
                        this.dataLoading = false;
                    });
                });
            } else {

                return new Promise((resolve, reject) => {
                    lastValueFrom(this.svc_data.saveOrderAttachmentData( busObj)).then((info: BaseMessageInfo) => {
                        if (!info.saveError && !info.existsAlready && !info.warning && info.primaryReturn) {
                            busObj.isViewable = this.isVisibleAttachmentType(busObj.attachmentType);
                            busObj.id = info.primaryReturn.orderAttachmentId;
                            retInfo.primaryReturn = busObj;
                            this.notify(this.appCode + " Saved Successfully!");
                        }
                        else {
                            retInfo.message = info.message;
                            retInfo.saveError = true;
                            this.saveError(info.primaryReturn as AttachmentBus, info.message ?? `Unable to upload file. ${CommonValues.ErrorMessages_BaseErrorSuffix}`);
                        }
                        this.clearUpload();
                        resolve(retInfo);
                        this.dataLoading = false;
                    }, (err) => {
                        console.error(err);
                        retInfo.message = `Unable to upload file. ${CommonValues.ErrorMessages_BaseErrorSuffix}`;
                        retInfo.saveError = true;
                        this.clearUpload();
                        this.saveError(busObj, retInfo.message);
                        reject(retInfo);
                        this.dataLoading = false;
                    });
                });

            }
        }
    }
    deleteIndividual(data: AttachmentBus) {
        if (data.hasId) {
            this.svc_data.deleteAttachment(data.id).subscribe((dataObj: BaseMessageInfo) => {
                if (!dataObj.saveError) {
                    this.deleteSuccess(data);
                    this.removeLocal(data);
                }
                else {
                    this.deleteError(data, dataObj.message);

                }
            });
        }
        else {
            this.closeEditor();
        }
    }
    public remove(upload: UploadComponent, uid: string) {
        upload.removeFilesByUid(uid);
    }
    public showButton(state: FileState): boolean {
        return (state === FileState.Selected) ? true : false;
    }
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    selectEventHandler(e: SelectEvent) {
        super.selectEventHandler(e);
        CommonFunctions.patchEditFormWithAttachment(this.files?.[0], this.editForm);
    }

    get showId(): boolean {
        return this.editedRowIndex == undefined && this.isNew == false ? true : false;
    }
    ngOnInit(): void {
        window.addEventListener("drop", e => {
            e && e.preventDefault();
        }, false);
        this.callSaveIndividualInsteadOfSave = true;
    }
    downloadingAllItems: boolean = false;
    downloadingAllItemsPhase: number = 0;
    attachmentsCombineAndDownload() {
        this.downloadingAllItems = true;
        this.downloadingAllItemsPhase = 1;
        this.dataLoading = true;
        this.svc_data.attachmentsCombineAndDownload(this.parentId).subscribe((info: BaseMessageInfo) => {

            this.document = new CDocument(info.primaryReturn);

            if (this.document.hasDocumentB64String) {
                this.document.setProperties();
                let downloadData = "data:" + this.document.mimeType + ";base64," + this.document.documentB64String;
                let size: number = info.dcValues.FileSize / 1000;
                let msecs = 5000;
                if (size > 175000) {
                    msecs = 115000;
                }
                else if (size > 125000) {
                    msecs = 50000;
                }
                else if (size > 75000) {
                    msecs = 30000;
                }
                else if (size > 5000) {
                    msecs = 15000;
                }
                this.downloadingAllItemsPhase = 2;
                saveAs(downloadData, this.document.fullFileName);
                timer(msecs).subscribe(s => {
                    this.dataLoading = false;
                    this.downloadingAllItems = false;
                    this.downloadingAllItemsPhase = 0;
                    this.notify("Pdf Attachments download complete.");
                });
            }
            else {
                this.viewingDocument = false;
                this.sendParentMessage(MessageType.msgPopup, "Missing Data", "No Pdf Attachment Data Found");
            }
        });
    }

    test() {
        console.log("order-att-test: ", this);
    }
}

